import { useState } from 'react';
import { KTSVG } from '../../../../../_dashboard/helpers';
import dataAxios from '../../../../modules/auth/core/dataAxios';
import { useIntl } from 'react-intl';

const API_URL = process.env.REACT_APP_API_URL || '';

const NewsletterListToolbar = () => {
  const intl = useIntl();
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    setExporting(true);
    try {
      const response = await dataAxios.get(`${API_URL}/newsletter-emails`, {
        params: { page: 0, size: 10000 },
      });
      const subscribers = response.data?.data || [];
      const header = 'Email,Statut,Date inscription';
      const rows = subscribers.map((s: { email: string; isSubscribed: boolean; createdAt?: string }) => {
        const status = s.isSubscribed ? 'Abonné' : 'Désabonné';
        const date = s.createdAt ? new Date(s.createdAt).toLocaleDateString('fr-FR') : '';
        return `"${s.email}","${status}","${date}"`;
      });
      const csv = [header, ...rows].join('\n');
      const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'newsletter-subscribers.csv';
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export failed', error);
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className='d-flex justify-content-end' data-kt-newsletter-table-toolbar='base'>
      <button
        type='button'
        className='btn btn-light-primary'
        onClick={handleExport}
        disabled={exporting}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        {exporting
          ? intl.formatMessage({ id: 'NEWSLETTER.EXPORTING' })
          : intl.formatMessage({ id: 'NEWSLETTER.EXPORT' })}
      </button>
    </div>
  );
};

export { NewsletterListToolbar };
